// language=GraphQL
export const ALL_AGE_GROUPED_TOTAL_CAPACITIES_QUERY = `query Query($withAgeGroups: Boolean = false) {
  ageGroupedTotalCapacities: accommodationAgeGroupedTotalCapacities {
    id
    ageGroups @include(if: $withAgeGroups) {
      id
      name
      type
      icon
      minAge
      maxAge
    }
    capacity
  }
}`

// language=GraphQL
export const SINGLE_AGE_GROUPED_TOTAL_CAPACITY_QUERY = `query Query($id: ID!, $withAgeGroups: Boolean = false) {
  ageGroupedTotalCapacity: accommodationAgeGroupedTotalCapacity(id: $id) {
    id
    ageGroups @include(if: $withAgeGroups) {
      id
      name
      type
      icon
      minAge
      maxAge
    }
    capacity
  }
}`

// language=GraphQL
export const CREATE_AGE_GROUPED_TOTAL_CAPACITY_MUTATION = `
  mutation Mutation($input: CreateAccommodationAgeGroupedTotalCapacityInput, $withAgeGroups: Boolean = false) {
    ageGroupedTotalCapacity: createAccommodationAgeGroupedTotalCapacity(input: $input) {
      id
      ageGroups @include(if: $withAgeGroups) {
        id
        name
        type
        icon
        minAge
        maxAge
      }
      capacity
    }
  }`

// language=GraphQL
export const UPDATE_AGE_GROUPED_TOTAL_CAPACITY_MUTATION = `
  mutation Mutation($input: UpdateAccommodationAgeGroupedTotalCapacityInput, $withAgeGroups: Boolean = false) {
    ageGroupedTotalCapacity: updateAccommodationAgeGroupedTotalCapacity(input: $input) {
      id
      ageGroups @include(if: $withAgeGroups) {
        id
        name
        type
        icon
        minAge
        maxAge
      }
      capacity
    }
  }`

// language=GraphQL
export const DELETE_AGE_GROUPED_TOTAL_CAPACITY_MUTATION = `
  mutation Mutation($input: DeleteAccommodationAgeGroupedTotalCapacityInput) {
    deleteAccommodationAgeGroupedTotalCapacity(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_AGE_GROUPED_TOTAL_CAPACITY_MUTATION = `
  mutation Mutation($input: DeleteAccommodationAgeGroupedTotalCapacityInput) {
    forceDeleteAccommodationAgeGroupedTotalCapacity(input: $input) {
      success
    }
  }`

// language=GraphQL
export const ADD_AGE_GROUPED_TOTAL_CAPACITY_AGE_GROUPS_MUTATION = `
  mutation Mutation($input: addAccommodationAgeGroupedTotalCapacityAgeGroupsInput) {
    addAccommodationAgeGroupedTotalCapacityAgeGroups(input: $input) {
      id
      ageGroupIds
    }
  }`

// language=GraphQL
export const REMOVE_AGE_GROUPED_TOTAL_CAPACITY_AGE_GROUPS_MUTATION = `
  mutation Mutation($input: removeAccommodationAgeGroupedTotalCapacityAgeGroupsInput) {
    removeAccommodationAgeGroupedTotalCapacityAgeGroups(input: $input) {
      id
      ageGroupIds
    }
  }`

// language=GraphQL
export const CREATE_AGE_GROUPED_TOTAL_CAPACITY_AGE_GROUPS_MUTATION = `
  mutation Mutation($input: createAccommodationAgeGroupedTotalCapacityAgeGroupsInput) {
    createAccommodationAgeGroupedTotalCapacityAgeGroups(input: $input) {
      id
      ageGroupIds
    }
  }`

// language=GraphQL
export const DELETE_AGE_GROUPED_TOTAL_CAPACITY_AGE_GROUPS_MUTATION = `
  mutation Mutation($input: deleteAccommodationAgeGroupedTotalCapacityAgeGroupsInput) {
    deleteAccommodationAgeGroupedTotalCapacityAgeGroups(input: $input) {
      id
      ageGroupIds
    }
  }`

// language=GraphQL
export const UPDATE_AGE_GROUPED_TOTAL_CAPACITY_AGE_GROUPS_ORDER_MUTATION = `
  mutation Mutation($input: updateAccommodationAgeGroupedTotalCapacityAgeGroupsOrderInput) {
    updateAccommodationAgeGroupedTotalCapacityAgeGroupsOrder(input: $input) {
      id
      ageGroupIds
    }
  }`

// language=GraphQL
export const AGE_GROUPED_TOTAL_CAPACITIES_DEPENDENTS_QUERY = `query Query($id: ID!, $withAccommodationCapacitySettings: Boolean = false) {
  groupedDependents: accommodationAgeGroupedTotalCapacityDependents(id: $id) {
    accommodationCapacitySettings @include(if: $withAccommodationCapacitySettings) {
      id
      totalCapacity
      rangesAllowed
      partialOccupancyAllowed
    }
  }
}`
